import { SignedInCompany } from "@revelate/types";

export const getCompanyInitials = (company: SignedInCompany | null) => {
  return company?.name.slice(0, 2).toUpperCase() || "";
};
